import { render, staticRenderFns } from "./OrderOptions.vue?vue&type=template&id=79bc474c"
import script from "./OrderOptions.vue?vue&type=script&lang=ts"
export * from "./OrderOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports